/* ============
 * Mutations for the project module
 * ============
 *
 */

import { LOAD, LOAD_TRANSLATIONS, SEND_QUESTION } from './mutation-types';

/* eslint-disable no-param-reassign */
export default {
  [LOAD](state, { order, project, theme }) {
    if (theme) {
      project.settings.theme = theme;
    }
    Object.assign(state, {
      order,
      project,
    });
  },
  [SEND_QUESTION](state) {
    // do noting
  },
  [LOAD_TRANSLATIONS](state, translations) {
    state.i18nTranslations = translations;
    // do nothing
  },
};
